<template>
  <v-container v-if="supplier.id > 0" class="new-home-on-table-view" id="NewHomeOnTableView">


    <chip-closed-supplier v-if="!supplier.active_delivery || !supplier.active_kitchen_service" />

    <div id="videoinmerser" v-if="instance.slug === 'colombia-tech-week'">
      <video ref='miVideo'  autoplay muted loop class="" playsinline>
        <source src="/mexicoNoche.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <div id="videoinmerser" v-if="instance.slug === 'demo-cluvipay-asoclubes'">
      <video ref='miVideo'  autoplay muted loop class="" playsinline>
        <source src="/video-la-recetta.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="contenthome"  v-for="item in content" :key="item.id" >

      <v-row v-if="item.layout_type === 'banner' && item.image !== null" cols="12" class="bannerhome">
        <v-col cols="12">
          <picture-banner :item="item" @loadBanner="loadBanner" @clickBanner="clickBanner" :data-testid="`HomeTabMain-${item.title}`" />
        </v-col>
      </v-row>

      <v-row v-if="item.layout_type === 'products'" :id="'block'+item.id" class="blockproducts">
        <v-col cols="12" class="pl-0 title-block-home pb-3 text-center">
          <h2 primary-title  v-html="item.title" />
        </v-col>
        <v-col v-for="product in item.products_label" :key="product.id" cols="6" lg="3">
          <newhome-product-card  class="" :product="product" :validateAddCheckout="true" />
        </v-col>
      </v-row>

      <div class="slider-container" v-if="item.layout_type === 'products' && instance.slug === 'colombia-tech-week'" :id="'block2'+item.id" >
        <div class="slider">
          <img
          v-for="n in 10"
            :key="n" 
          src="https://images.cluvi.com/8lFXRY9wFY/mini_8lFXRY9wFY_logo-1.png" alt="Imagen Rotante" />
        </div>
      </div>
      <div class="slider-container" v-if="item.layout_type === 'products' && instance.slug === 'demo-cluvipay-asoclubes'" :id="'block2'+item.id" >
        <div class="slider">
          <img
          v-for="n in 10"
            :key="n" 
          src="https://images.cluvi.com/69WN9Sc3qi/thumb_69WN9Sc3qi_logo-la-recceta.png" alt="Imagen Rotante" />
        </div>
      </div>
      
      <v-row v-if="item.layout_type === 'slide-products' " class="secondproducts" >
        <v-col v-for="product in item.products_label" :key="product.id" cols="6" lg="3">
          <newhome-product-card  class="" :product="product" :validateAddCheckout="true" />
        </v-col>
      </v-row>

    </div>

    <current-cart-bottom v-if="!this.template.loading" />

  </v-container>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { misMixins } from "@/mixins/mixins.js";
import { menu } from "@/services/menu";
import { track } from "@/services/track-custom";

export default {
  name: "OnTableNewHome",
  components: {
    CurrentCartBottom: () => import (/* webpackChunkName: "currentCartBottom" */  '@/components/on_table/CurrentCartBottom.vue'),
    ChipClosedSupplier: () => import(/* webpackChunkName: "ChipClosedSupplier" */ "@/components/share/ChipClosedSupplier.vue"),
    PictureBanner: () => import(/* webpackChunkName: "PictureBanner" */ "@/components/share/PictureBanner"),
    NewhomeProductCard: () => import(/* webpackChunkName: "NewhomeProductCardSmall" */'@/components/product-card/newhome/ProductCard.vue'),
  },
  data() {
    return {
      content: []
    };
  },
  computed: {
    ...mapState("customer", ["supplier", "instance"]),
    ...mapState("template", ["template"])
  },
  created() {
    this.SetLoading(true);
    menu.getContentHome(this.supplier.id, this.service)
      .then(response => {
        this.SetLoading(false);
        this.content = response.data;
      })
      .catch(error => {
        (error);
      })
  },
  mixins: [misMixins],
  methods: {
    ...mapMutations("template", ["SetLoading"]),
    loadBanner(content_home) {
      track.trackEventCluvi({ content_home: content_home }, "open banner");
    },
  },
  mounted() {}
};
</script>

<style  lang="scss">

#videoinmerser{
  text-align: center;
  margin:  -12px;
  video{
    width: 100%;
    margin: 0 auto;
  }
}

.slider-container {
  margin: 12px -12px 12px -12px;
  padding: 15px;
  background-color:#1F1F1F;
  overflow: hidden;
  display: flex;
  .slider {
    display: flex;
    animation: slide 100s linear infinite; /* Ajusta la duración del slide */
  }
  .slider img {
    width: 141px; /* Ajusta el tamaño de la imagen */
    height: auto;
    padding-left: 60px;
  }
  @keyframes slide {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }
}



.blockslides{
  background-color:#1F1F1F;
  img{
    margin-left: 50px!important;
  };
}

.blockproducts{
  background-color:#1F1F1F;
  p{
    margin-bottom: 0px;
  }
  .title-block-home{
    color: #FFF;
  }
  .card{
    background-color: transparent;
    color: #fff!important;
    h3{
      color: #fff;
      font-weight: bolder;
    }
    p{
      color: #fff;
      p{
        color: #fff;    
      }
    }
  }
}

.secondproducts{
  background: linear-gradient(to bottom, #1F1F1F 0px, #1F1F1F 80px, white 80px, white 100%);
  .title-block-home{
    color: #1f1f1f;
  }
  .card{
    background-color: transparent;
    color: #1F1F1F;
    img{
      background-color: #FFF;
    }
  }
}
</style>
